// eslint-disable-next-line no-unused-vars
import { createSelector } from '@reduxjs/toolkit';

export const payment = (state) => state.payment;

export const shouldLockPayments = createSelector(
  payment,
  (state) => state?.shouldLockPayments,
);
